import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import { catchError } from '../../helpers/catch-error'
import logo from "../../../assets/images/logo.png";
import { getStatus } from '../../helpers/common'




const WorkOrdersFacilityReportPrint = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [workOrders, setWorkOrders] = React.useState(null);
    const [facility, setFacility] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();

    const start_date = searchParams.get("start_date");
    const end_date = searchParams.get("end_date");
    const report_type = searchParams.get("report_type");
    const status = searchParams.get("status");



    useEffect(() => {

        getFacility();

        getWorkOrders();
        console.log(params)

    }, []);



    const getFacility = async (facility_id) => {
        
        axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-facility-by-id/" + params.facility_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setFacility(response?.data?.facility);


            } else {

                Swal.fire({ icon: "error", title: "Facility Info", text: response?.data?.message });

            }
        }).catch(function (error) {

            catchError(error, navigate)
        });

    }




    const getWorkOrders = () => {

        var search_elements = {}
        search_elements.facility_id = params?.facility_id;
        search_elements.start_date = start_date;
        search_elements.end_date = end_date;
        search_elements.report_type = report_type;
        search_elements.status = status;

       
        axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/admin/get-report-work-orders-facility", search_elements, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        }).then(function (response) {

            if (response?.data?.status) {

                setWorkOrders(response?.data?.work_orders);

            }
            else {

                setWorkOrders(null);

            }


        }).catch(function (error) {

            // setIsBtn(false);
            catchError(error, navigate)

        });


    }


    return (
      
        <div className="printonly ">
            {facility?.facility_id > 0 && 
        <table width="720px" cellpadding="0" cellspacing="0" align="center" className="heading watermarked" >
                      <tr>
                        <td className="heading-address" >
                            <img src={logo} width="200" border="0"  />
                            <br/>
        
                            POST OFFICE BOX 2191<br/>
                            SAN LEANDRO, CA 94577<br/>
                            PHONE:{process.env.REACT_APP_SUPPORT_PHONE_NUMBER} SECURE FAX: {process.env.REACT_APP_SUPPORT_FAX}<br/>
                            MedRecAps &lt;{process.env.REACT_APP_ADMIN_EMAIL}&gt; <br/>
                        </td>
        
                       
                    </tr>
                    <tr>
                        <td  >
                        Please Update The Status Of The Following Cases And Fax Or Email Back.
                        </td>
                    </tr>

                    <tr>
                        <td >
                          <hr/>
                        </td>
                    </tr>

                    <tr>
                        <td className="" >
                          <h4>FACILITY INFORMATION:</h4>
                         
                          {facility?.facility_name}<br/>
                           {"Attn:"+facility?.facility_attn}<br/>
                           {facility?.facility_address}<br/>
                           {facility?.facility_city+", "}
                           {facility?.facility_state+" "}
                           {facility?.facility_zip}<br/>
                  
                   
                           {facility?.facility_phone?"Ph:"+facility?.facility_phone+" ":""}
                           {facility?.facility_fax?"Fax:"+facility?.facility_fax:""}
                           <br/>
                           <br/>
                        </td>
                    </tr>

                    <tr>
                        <td>
                        			  
<table className="table table-responsive table-border">
                        <tr className="background-alice-blue" >
                <th className="heading-col"  >Case Date</th> 
                <th className="heading-col"  >Patient Name</th> 
                <th className="heading-col" >DOB</th> 
                <th className="heading-col" >Med Rec No.</th> 
                <th className="heading-col" >SSN</th> 
                <th className="heading-col" >Current Status</th> 
             </tr>

             {workOrders?.map((row, index) => {
                                    return (
                                        <tr className="background-alice-blue" >
                                        <td className=""  >{row.wo_creation_date}</td> 
                                        <td className=""  >{row.patient_last_name + ", " + row.patient_first_name}</td> 
                                        <td className="" >{row.patient_dob_formatted}</td> 
                                        <td className="" >{row.patient_med_rec_num}</td> 
                                        <td className="" >{row.patient_ssn}</td> 
                                        <td className="" >{getStatus(row.status )}</td> 
                                     </tr>
                                    )
                                })}


            </table>
                        </td>
                    </tr>
        </table>
        }
        </div>

     


    );
};

export default WorkOrdersFacilityReportPrint;